<script>
import { insTypeOrders } from 'base/config'
import Insurance from 'base/model/insurance'

export default {
  name: 'LiabilityTable',
  props: {
    init: {
      type: Boolean,
      default: false,
    },
    members: {
      type: Array,
      default() {
        return []
      },
    },
    resultData: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  data() {
    return {}
  },
  methods: {
    _format(prodId, template = '', data = {}) {
      let self = this
      let keys = Object.keys(data)
      let dataList
      dataList = keys.map(function (key) {
        // 根据产品id获取对应险种数据
        if (key.match(/i\d+/)) {
          if (data[key] && data[key]['p' + prodId]) {
            return data[key]['p' + prodId]
          } else {
            return new Insurance()
          }
        }
        return data[key]
      })

      // -- start 12.15 --
      if (!template) template = ''
      const stuff = this._stuffingTemplateIns(template, keys, dataList)
      keys = stuff.keys
      dataList = stuff.dataList

      // -- end 12.15 --

      // 这里使用反引号来构建模板引擎
      // let Fn = new Function
      let g = new Function(
        keys.join(','),
        'return this._formatFnCenter `' + template + '`;'
      )
      return g.apply(self, dataList)
    },
    _formatFnCenter(templateData) {
      var resultTemp = templateData[0]

      for (var i = 1; i < arguments.length; i++) {
        var arg = String(arguments[i])

        // 金额显示整万
        if (templateData[i].match(/元/)) {
          arg = String(this._formatTenThousand(arg))
        }

        // 金额显示保留2位小数
        // fix 纯数字才进入逻辑
        if (!isNaN(arg) && arg.split('.')[1]) {
          arg = arg.split('.')[1].length > 2 ? parseFloat(arg).toFixed(2) : arg
        }
        resultTemp += arg
        resultTemp += templateData[i]
      }
      return resultTemp
    },
    _formatTenThousand(number) {
      var regExp = /^[+-]?[1-9]?[0-9]*\.[0-9]*$/,
        result = 0
      if (!(typeof parseFloat(number) === 'number')) return number
      number = parseFloat(number)
      if (number % 10000 === 0 && number >= 10000) {
        number = number / 10000
        result = (regExp.test(number) ? number.toFixed(2) : number) + '万'
      } else {
        result = regExp.test(number) ? number.toFixed(2) : number
      }
      return result
    },
    _createLiabilities(prodId, liab) {
      let ret = []
      let { data, __c, _format, _formatLow, _formatASCII } = this
      let targetAry = liab
      if (!Array.isArray(liab)) {
        targetAry = [liab]
      }
      targetAry.forEach((lib) => {
        lib &&
          showKeys.forEach((sk) => {
            let libItem = lib[sk]
            if (libItem) {
              let resultHTML
              try {
                resultHTML = _format(prodId, libItem, data)
              } catch (er) {
                resultHTML = _formatLow(prodId, libItem, data)
              }
              resultHTML = _formatASCII(resultHTML)

              let libVNode
              // fix 无文字时插入空的dom
              if (resultHTML) {
                // 文字预处理
                preHandleKeys.length &&
                  preHandleKeys.forEach((pre, index) => {
                    if (pre.key === sk) {
                      resultHTML = pre.value.replace(/{(.*?)}/, resultHTML)
                    }
                  })

                libVNode = __c('div', {
                  class: sk,
                  domProps: {
                    innerHTML: resultHTML,
                  },
                })
                ret.push(libVNode)
              }
            }
          })
      })

      return ret
    },
    _stuffingTemplateIns(template, keys, dataList) {
      let tpKeys = template.match(/i\d+/g)
      tpKeys = [...new Set(tpKeys)]
      let iKeys = keys.filter((k) => {
        return k.match(/i\d+/)
      })

      let notKeys = tpKeys.filter((d) => {
        return iKeys.indexOf(d) === -1
      })

      notKeys.forEach((nk) => {
        keys.push(nk)
        dataList.push(new Insurance())
      })

      return {
        keys,
        dataList,
      }
    },
    getMemberInsLen(list) {
      let len = 0
      if (!list || !Array.isArray(list)) return
      list.forEach((pb) => {
        if (!pb.liabilities) return
        pb.liabilities.forEach((ins) => {
          const iLab = ins.insuranceLiabilities
          const iLen = (iLab && iLab.length) || 0
          len += iLen
        })
      })
      return len
    },
    getMemberProLen(list) {
      let len = 0
      if (!list || !Array.isArray(list)) return
      list.forEach((ins) => {
        const iLab = ins.insuranceLiabilities
        len += iLab && iLab.length
      })
      return len
    },
    getInsCategoryName(ins) {
      if (!ins || !Array.isArray(ins)) return ''
      const categorySort = ins.categorySort || 'normal'
      const insTypeIndex = insTypeOrders[categorySort]
      let category = []
      ins.forEach((item) => {
        const index = insTypeIndex.indexOf(item.categoryId)
        if (category[index]) return
        category[index] = item.categoryName
      })
      return category.join(' ')
    },
  },
}
</script>

<template>
  <div class="liability-table">
    <table
      v-if="init && members && members.length"
      class="responsibility-table"
    >
      <thead>
        <tr>
          <th>被保人</th>
          <th>保障计划</th>
          <!-- <th>产品名称</th> -->
          <th>险种</th>
          <th>保障</th>
          <th>利益说明</th>
          <th>利益注释</th>
        </tr>
      </thead>
      <tbody v-for="(tb, ti) in members">
        <template v-for="(pb, ib) in resultData[tb.cid].lib.insurances">
          <template v-for="(pd, ip) in pb.liabilities">
            <tr
              v-for="(ins, ii) in pd.insuranceLiabilities"
              :data-m="ti"
              :data-r="ib"
              :data-l="ip"
              :data-i="ii"
            >
              <template v-if="ib === 0 && ip === 0 && ii === 0">
                <td
                  :rowspan="getMemberInsLen(resultData[tb.cid].lib.insurances)"
                >
                  {{ tb.name }}
                </td>
              </template>
              <template v-if="ip === 0 && ii === 0">
                <td :rowspan="getMemberProLen(pb.liabilities)">
                  {{ pb.insuranceName }}
                </td>
              </template>
              <!-- <template v-if="ii === 0">
                  <td :rowspan="pd.insuranceLiabilities.length">{{pb.resultData.productGroupList[0].prodOrderList[ip].titleName}}</td>
                </template> -->
              <td>{{ ins.insuranceName }}</td>
              <td v-html="getInsCategoryName(ins.liabilities)" />
              <td>
                <div class="ins">
                  <div
                    v-for="lb in ins.liabilities"
                    v-if="lb.description1"
                    class="description1"
                    v-html="
                      _format(
                        pd.productId,
                        lb.description1,
                        resultData[tb.cid].calAry[ib]
                      )
                    "
                  />
                </div>
              </td>
              <td>
                <div class="ins">
                  <div v-for="lb in ins.liabilities">
                    <div
                      class="description2"
                      v-html="
                        _format(
                          pd.productId,
                          lb.description2,
                          resultData[tb.cid].calAry[ib]
                        )
                      "
                    />
                    <div
                      class="comment"
                      v-html="
                        _format(
                          pd.productId,
                          lb.comment,
                          resultData[tb.cid].calAry[ib]
                        )
                      "
                    />
                  </div>
                </div>
              </td>
            </tr>
          </template>
        </template>
        <tr v-if="resultData[tb.cid].lib.insurances" class="remark">
          <td>备注说明</td>
          <td colspan="6" />
        </tr>
      </tbody>
    </table>
  </div>
</template>

<style lang="postcss" scoped>
@import 'variable';

.description1 {
  position: relative;
  margin-bottom: 5px;
  margin-top: 4px;
  line-height: 21px;
  font-size: 15px;
  text-align: justify;
  span {
    position: relative;
    top: 1px;
    font-size: 18px;
    font-weight: 500;
    margin: 0 3px;
    line-height: 1;
    color: #ffb23e;
  }
  &:before {
    content: '';
    position: absolute;
    left: -10px;
    top: 8px;
    border: 3px solid var(--nine-color);
    border-radius: 50%;
    vertical-align: middle;
  }
}

.description2 {
  margin-bottom: 5px;
  font-size: 14px;
  line-height: 20px;
  color: var(--nine-color);
}

.waitingDuration,
.comment {
  font-size: 14px;
  margin-bottom: 15px;
  line-height: 20px;
  color: var(--nine-color);
}

.comment {
  /*display: none;*/
  margin-top: -2px;
  text-align: justify;
}

.responsibility-table {
  margin-bottom: 30px;
  thead {
    th {
      background-color: #ffb23e;
      color: #fff;
    }
  }
  th {
    &:nth-child(1) {
      width: 8%;
    }
    &:nth-child(2) {
      width: 12%;
    }
    /*&:nth-child(3) {
        width: 9%;
      }*/
    &:nth-child(4) {
      width: 10%;
    }
    &:nth-child(5) {
      width: 25%;
    }
    &:nth-child(6) {
      width: 30%;
    }
  }
  .remark {
    background-color: #fdfdfd;
    td:first-child {
      color: #999;
    }
  }
}
</style>